/* eslint-disable */
import { useParams } from 'react-router-dom';
import { ReduxHOC } from 'HOC';
import PrivateLobby from 'Pages/PrivateLobby';
import PublicLobby from 'Pages/PublicLobby';
import { API, Auth, Http, Utils, Constant } from 'Helpers';
import { useEffect, useState } from 'react';
import { SessionStorage } from 'Helpers/Utilieties';
import { useTranslation } from 'react-i18next';

// const { REACT_APP_DOC_TITLE } = process.env;
const Lobby = (props) => {
  let leaguesBySport = {};
	const { t } = useTranslation();

  const { league_id, contest_id } = useParams();
  const [isApiCalling, setApiCalling] = useState(true);
  const [contestDt, setContestDt]= useState({});
  const lobbyProps = {
    ...props,
    leagueId: league_id || null,
    contestId: contest_id || null,
  };
	const GetLobbyContest = (contestId) => {
 		Http.post(API.GET_LOBBY_CONTEST_LIST, {contest_id: contestId})
			.then((res) => {
				if (res?.response_code === Constant.SUCCESS_CODE) {
	          if(res.data && res.data.contest_list && res.data.contest_list.length>0){
	            setApiCalling(false);
	            localStorage.setItem('contestData',JSON.stringify(res.data.contest_list[0]))
				setContestDt(res.data.contest_list[0]);
	          } else {
	            setApiCalling(false);
	          }
				} else {
					console.error(t('Unexpected response'), res);
					setApiCalling(false);
				}
			})
			.catch((error) => {
				console.error(t('Failed to fetch lobby contests'), error);
				setApiCalling(false);
			});
		};

  useEffect(()=>{	
    if(league_id && contest_id){
    setApiCalling(true);
		Http.post(API.SPORTS_LEAG_LIST).then(res => {
			const { data } = res;
			Utils.setLeagueData(data);
			SessionStorage.set('allLeaguesSports',data);
			GetLobbyContest(contest_id)
			const leagueData = data;

			// Ensure that the data exists and has the required structure
			if (leagueData && leagueData.sports && leagueData.leagues) {
			leagueData.sports.forEach(sport => {
				const sportId = sport.sports_id;
				const sportName = sport.sports_name;

				// Check if the sport already has an entry in the leaguesBySport object
				if (!leaguesBySport[sportName]) {
				leaguesBySport[sportName] = [];
				}

				// Get leagues for the current sport from the leagues object
				if (leagueData.leagues[sportId]) {
				// Extract the league names and push them into the sport's array
				const leagueNames = leagueData.leagues[sportId].map(league => league.league_name);
				leaguesBySport[sportName] = leagueNames;
				}
			});
			} else {
			console.warn(t('League data is empty or in an unexpected format'));
			}
			}).catch(err => {
				console.log(err);
				setApiCalling(false);
			})
    }else{
      setApiCalling(false);
	 setContestDt(JSON.parse(localStorage.getItem('contestData')) || {});
    }
	},[league_id, contest_id])
    
	if(isApiCalling){
		return <Utils.FlexboxLoader init className='lobby-loader' />
	}else{
   return <>{Auth.getAuth() ?
     contestDt && contestDt.league_id && <PrivateLobby {...lobbyProps} />
    :
    contestDt && contestDt.league_id && <PublicLobby {...lobbyProps} />
     }
	</>;
  }
};


export default ReduxHOC(Lobby);